import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { AiOutlineSearch } from 'react-icons/ai';

function SearchBar({
  onChange,
  value,
  containerClassName,
  inputClassName,
  ...otherProps
}) {
  const handleChange = (e) =>
    onChange((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));

  return (
    <div className={cn('flex items-center', containerClassName)}>
      <input
        className={cn(
          'rounded-[0.2rem] h-[40px] w-[260px] text-gray-500 focus:ring-transparent focus:border-gray-200 border-gray-200 bg-transparent font-[500] text-[0.7rem]',
          inputClassName,
        )}
        placeholder="Search"
        type="text"
        onChange={handleChange}
        value={value}
        autoComplete="off"
        {...otherProps}
      />
      <AiOutlineSearch className="w-4 h-4 text-gray-400 -ml-6" />
    </div>
  );
}

SearchBar.defaultProps = {
  containerClassName: '',
  inputClassName: '',
};

SearchBar.propTypes = {
  containerClassName: PropTypes.string,
  inputClassName: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
};

export default SearchBar;
